exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper-kernactiviteit{display:flex;flex-direction:row;justify-content:space-between;align-items:flex-start}.wrapper-kernactiviteit img{margin-left:var(--item-margin);height:240px;object-fit:contain}@media only screen and (max-width:600px){.wrapper-kernactiviteit{flex-direction:column}.wrapper-kernactiviteit img{width:100%;object-fit:cover;margin:0 0 var(--item-margin)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-636ff5f0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content-takenpakket.vue
// module id = 43
// module chunks = 0